export default "__VITE_ASSET__0c3c015e__"